export const POLL_INTERVAL_MS = 5000;
export const MAX_POLL_ATTEMPTS = 60;
export const SPEAKER_ROLES = ['practitioner', 'patient', 'unknown'];

export const getRecordingMimeType = () => {
    const candidates = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
    ];
    if (typeof window === 'undefined' || !window.MediaRecorder?.isTypeSupported) return '';
    return candidates.find((candidate) => window.MediaRecorder.isTypeSupported(candidate)) || '';
};

export const formatElapsed = (ms) => {
    const totalSeconds = Math.max(0, Math.floor((ms || 0) / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export const statusConfig = (status) => {
    switch (status) {
        case 'ready':
            return { label: 'Ready', color: 'success', icon: 'solar:check-circle-bold' };
        case 'processing':
            return { label: 'Processing', color: 'info', icon: 'solar:refresh-bold' };
        case 'uploaded':
            return { label: 'Queued', color: 'info', icon: 'solar:cloud-upload-bold' };
        case 'failed':
            return { label: 'Failed', color: 'error', icon: 'solar:close-circle-bold' };
        case 'recording':
            return { label: 'Recording', color: 'warning', icon: 'solar:record-bold' };
        default:
            return { label: status || 'Unknown', color: 'default', icon: 'solar:microphone-bold' };
    }
};

export const buildEndpoint = (practiceId, leadId, suffix = '') => (
    `/api/v1/practices/${practiceId}/leads/${leadId}/consultation-recordings/${suffix}`
);

export const getSpeakerLabel = (speaker, speakerMap = {}) => {
    const mapped = speakerMap?.[speaker] || speaker;
    if (mapped === 'practitioner') return 'Practitioner';
    if (mapped === 'patient') return 'Patient';
    if (mapped === 'unknown') return 'Unknown';
    return `Speaker ${mapped || speaker || '?'}`;
};

export const getSpeakerRoleValue = (speaker, speakerMap = {}) => {
    const mapped = speakerMap?.[speaker] || speaker;
    return SPEAKER_ROLES.includes(mapped) ? mapped : 'unknown';
};
